/* eslint-disable global-require */

if (process.env.BROWSER) {
  module.exports = require('./fetch.client.js');
} else {
  module.exports = require('./fetch.server.js');
}



// WEBPACK FOOTER //
// ./src/utils/fetch/index.js